/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Delete_Confirm_TitleInputs */

const en_company_jobs_delete_confirm_title = /** @type {(inputs: Company_Jobs_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Really delete job?`)
};

const de_company_jobs_delete_confirm_title = /** @type {(inputs: Company_Jobs_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle wirklich löschen?`)
};

/**
* | output |
* | --- |
* | "Really delete job?" |
*
* @param {Company_Jobs_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_delete_confirm_title = /** @type {((inputs?: Company_Jobs_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Delete_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_delete_confirm_title(inputs)
	return en_company_jobs_delete_confirm_title(inputs)
});